module.exports = __webpack_public_path__ + "img/9AI-改3_02.a967a150.jpg";